<template>
  <div>
    <div class="message-stream">
      <span v-if="isCursorBlinking" class="blinking-cursor">|</span>
      <div ref="preRef" :class="['message-marked']" v-html="displayedContent" />
    </div>
  </div>
</template>

<script lang="ts">
import vue from '../../../../adapter-vue';
import { IMessageLargeStreamPayload } from '../../../../interface';
import { parseMarkdown } from './message-desk/message-desk-elements/marked';
import { TypeWriter } from "./message-desk/message-desk-elements/type-writer";
import { JSONToObject } from "../../../../utils";
interface Props {
  content: IMessageLargeStreamPayload;
}
const __sfc_main = {};
__sfc_main.props = {
  content: {
    key: "content",
    required: false,
    type: null,
    default: () => ({}) as IMessageLargeStreamPayload
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref,
    computed,
    watch,
    onMounted,
    onUnmounted
  } = vue;
  const props = __props;
  const isCursorBlinking = ref<boolean>(true);
  const isStreaming = ref<boolean>(false);
  const markdown = ref<string>('');
  const isStreamEnded = ref<boolean>(true);
  const prevmarkdownLength = ref<number>(0);
  const streamContent = ref<string>('');
  const displayedContent = computed(() => {
    // @ts-ignore
    window.onMarkdownImageClicked = function (href: string) {
      emits('previewImage', decodeURIComponent(href));
    };
    // @ts-ignore
    window.onMarkdownMediaLoad = function () {
      // empty implementation
      // 已经用 ResizeObserver 观测高度，这里不用重复通知高度变化
    };
    const result = parseMarkdown(streamContent.value);
    return result;
  });
  const preRef = ref();
  const emits = __ctx.emit;
  // 不支持 ResizeObserver 的浏览器太老旧，默认不处理了
  const canIUseResizeObserver = typeof ResizeObserver === 'undefined' ? false : true;
  let observer;
  let prevHeight;
  const typeWriter = new TypeWriter({
    batchSize: 2,
    onTyping: (item: string) => {
      streamContent.value += item;
    },
    onComplete() {
      isStreaming.value = false;
    }
  });
  function startStreaming(content: string[]) {
    if (!isStreaming.value) {
      isStreaming.value = true;
      typeWriter.add(content);
      typeWriter.start();
    } else {
      typeWriter.add(content);
    }
  }
  watch(() => props.content, (newValue: IMessageLargeStreamPayload, oldValue: IMessageLargeStreamPayload) => {
    if (!newValue || oldValue && newValue.markdown === oldValue.markdown) {
      return;
    }
    const _payloadObject = props.content;
    if (_payloadObject.errorCode !== 0 || !_payloadObject.markdown) {
      return;
    }
    markdown.value = _payloadObject.markdown || '';
    isStreamEnded.value = _payloadObject.isStreamEnded;

    // hide blinking cursor
    if (markdown.value.length > 0) {
      isCursorBlinking.value = false;
    }
    if (newValue && (!oldValue && isStreamEnded.value || markdown.value.length > 500)) {
      // disable typeWriter style or history message first load
      streamContent.value = markdown.value;
      prevmarkdownLength.value = markdown.value.length;
    } else {
      // 判断长度是为了防御编辑的内容回退和内容重复的异常 case
      if (markdown.value.length > prevmarkdownLength.value) {
        const _newmarkdownToAdd = markdown.value?.slice(prevmarkdownLength.value);
        prevmarkdownLength.value = markdown.value.length;
        startStreaming([_newmarkdownToAdd]);
      }
    }
  }, {
    deep: true,
    immediate: true
  });
  onMounted(() => {
    if (canIUseResizeObserver) {
      observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          observeHeightChanged(entry.contentRect.height);
        }
      });
      // 开始观察
      observer.observe(preRef.value);
    }
  });
  onUnmounted(() => {
    if (canIUseResizeObserver) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }
  });
  const observeHeightChanged = newHeight => {
    if (prevHeight !== newHeight) {
      prevHeight = newHeight;
      emits('heightChanged');
    }
  };
  return {
    isCursorBlinking,
    displayedContent,
    preRef
  };
};
export default __sfc_main;
</script>
<style lang="scss" scoped>
@import "../../style/common.scss";
.message-stream {
  overflow-wrap: break-word;
  word-break: normal;
  white-space: normal;
  font-size: 14px;
  user-select: text;
}

::v-deep .message-marked li {
  list-style: disc;
  margin-left: 1.5em;
}

.blinking-cursor {
  animation: blink 0.8s step-end infinite;
  color: #000;
}

@keyframes blink {
  from, to { opacity: 1; }
  50% { opacity: 0; }
}
</style>
